import React from 'react';
import { motion } from 'framer-motion';
const audience = ['Ya están cansados de la teoría', 'Quieren consistencia, no inspiración', 'Tienen poco tiempo', 'Quieren un sistema portable, aunque cambie la herramienta'];
const objections = [{
  q: 'No soy técnico.',
  a: 'Perfecto. Esto es copiar/pegar + checklists. Cero código.'
}, {
  q: 'Ya compré cursos y me estafaron.',
  a: 'Esto es un manual operativo: o queda funcionando o no cuenta. Sin promesas infladas.'
}, {
  q: 'No tengo tiempo.',
  a: 'Por eso son 3 bloques cortos. Si no puedes liberar 60–120 min, el problema no es IA: es falta de sistema.'
}];
export function AudienceSection() {
  return <section className="w-full py-24 px-6 bg-[#050505]" data-id="element-1">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-2">
        {/* Who it's for */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-3">
          <h2 className="text-3xl font-bold text-[#f0f0f0] mb-8" data-id="element-4">
            Para quién es
          </h2>
          <p className="text-gray-400 mb-6" data-id="element-5">
            Para creadores y equipos de infoproductos que:
          </p>
          <ul className="space-y-4" data-id="element-6">
            {audience.map((item, i) => <li key={i} className="flex items-center space-x-3 text-gray-300" data-id="element-7">
                <span className="w-1.5 h-1.5 bg-[#00d4aa] rounded-full" data-id="element-8" />
                <span data-id="element-9">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Objections */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-10">
          <h2 className="text-3xl font-bold text-[#f0f0f0] mb-8" data-id="element-11">
            Objeciones (resueltas)
          </h2>
          <div className="space-y-8" data-id="element-12">
            {objections.map((obj, i) => <div key={i} className="space-y-2" data-id="element-13">
                <h3 className="text-xl font-bold text-white" data-id="element-14">"{obj.q}"</h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-15">{obj.a}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}